const _excluded = ["title", "children", "togglePanelView", "isOpen", "setIsOpen"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useState } from 'react';
import { IconButton, Typography } from 'seagull';
import cn from 'classnames';
import { WideArrowDownward, WideArrowUpward } from 'seagull/icons';
import styles from "./FormlingContainer.module.scss";
export default function FormlingContainer(_ref) {
  let {
      title,
      children,
      togglePanelView = false,
      isOpen = false,
      setIsOpen
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const [showChildren, setShowChildren] = useState(!togglePanelView || isOpen);
  useEffect(() => {
    if ((!togglePanelView || isOpen) !== showChildren) {
      setShowChildren(!togglePanelView || isOpen);
    }
    // eslint-disable-next-line react-hooks-static-deps/exhaustive-deps
  }, [isOpen, togglePanelView]);
  function toggle() {
    if (togglePanelView) {
      setShowChildren(!showChildren);
      setIsOpen === null || setIsOpen === void 0 || setIsOpen(!showChildren);
    }
  }
  return /*#__PURE__*/React.createElement("section", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.titleContainer, togglePanelView && styles.clickableHeader),
    onClick: toggle,
    "data-testid": rest['data-testid'] && "".concat(rest['data-testid'], "-header")
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    weight: "normal",
    className: styles.title
  }, title), togglePanelView && /*#__PURE__*/React.createElement("span", {
    className: styles.menuButtonContainer
  }, /*#__PURE__*/React.createElement(IconButton, null, showChildren ? /*#__PURE__*/React.createElement(WideArrowUpward, null) : /*#__PURE__*/React.createElement(WideArrowDownward, null)))), /*#__PURE__*/React.createElement("div", {
    hidden: !showChildren,
    "data-testid": rest['data-testid'] && "".concat(rest['data-testid'], "-content"),
    className: styles.content
  }, children));
}